<template>
  <div class="opera-member">
    <topNav :title="$t('member_title')"></topNav>
    <date-hotel v-on:getDate="getDate" v-on:getHotel="getHotel" :defaultDate='memberReq.d'
                :defaultHotel='hotelName'></date-hotel>
    <div class="content">
      <div class="membertable">
        <div class="select clearfix">
          <div class="options">
            <div class="name">{{$t('member_time_type')}}</div>
            <div class="parent" :class="{focus:this.selectedInput==0}">
              <input type="text" v-model='selectStr' @touchstart="showPop(0)" readonly="readonly" v-on:change="change">
              <i class="iconfont icon-xia" @touchstart="showPop(0)"></i>
            </div>
          </div>
          <div class="options mroption">
            <div class="name">{{$t('member_mroption')}}</div>
            <div class="parent" :class="{focus:this.selectedInput==1}">
              <input type="text" v-model='selectStrTwo.text' @touchstart="showPop(1)" readonly="readonly"
                     v-on:change="change('type')">
              <i class="iconfont icon-xia" @touchstart="showPop(1)"></i>
            </div>
          </div>
        </div>
        <div class="memberMoney clearfix">
          <div class="m1 mm">
            <p class="money">{{memberInfo.buyCountSum}}</p>
            <p class="category">{{$t('member_new_member')}}</p>
            <span class="line"></span>
          </div>
          <div class="mm">
            <p class="money" style="color: #FF485F;" v-if="memberInfo.dis">
              <formatKW :dis="memberInfo.dis" :value="memberInfo.paySum"></formatKW>
            </p>
            <p class="category">
              <span>{{$t('member_pay')}}</span>
              <router-link
                :to="'/opera/memberDetailPay?type='+memberReq.type+'&start='+this.dateF(memberInfo.start)+'&end='+this.dateF(memberInfo.end)+'&level='+this.memberReq.level"
                class="detail"> {{$t('member_pay_detail')}}
              </router-link>
            </p>
            <span class="line"></span>
          </div>
          <div class=" mm">
            <p class="money" style="color: #FF485F;" v-if="memberInfo.dis">
              <formatKW :dis="memberInfo.dis" :value="memberInfo.chargeSum"></formatKW>
            </p>
            <p class="category">
              <span> {{$t('member_charge')}}</span>
              <router-link
                :to="'/opera/memberDetailCharge?type='+memberReq.type+'&start='+this.dateF(memberInfo.start)+'&end='+this.dateF(memberInfo.end)+'&level='+this.memberReq.level"
                class="detail"> {{$t('member_pay_detail')}}
              </router-link>
            </p>
          </div>
        </div>
        <table class="table">
          <tr>
            <th>{{$t('member_card_type')}}</th>
            <th>{{$t('member_new_member')}}</th>
            <th>{{$t('member_pay')}}</th>
            <th>{{$t('member_charge')}}</th>
          </tr>
          <tr v-for='(item,key) in memberInfo.cardInfo' :key="key">
            <td>{{item.cardTypeDec}}</td>
            <td>{{item.buyCount}}</td>
            <td>{{item.pay}}</td>
            <td>{{item.charge}}</td>
          </tr>
        </table>

      </div>
      <div class="chartT">
        <div class="options">
          <div class="name">{{$t('member_ship_card')}}</div>
          <div class="parent" :class="{focus:this.selectedInput==2}">
            <input type="text" v-model='selectStrTree' @touchstart="showPop(2)" readonly="readonly"
                   v-on:change="cardChange">
            <i class="iconfont icon-xia" @touchstart="showPop(2)"></i>
          </div>


        </div>
        <div class="options mroption">
          <div class="name"> {{$t('member_data_class')}}</div>
          <div class="parent" :class="{focus:this.selectedInput==3}">
            <input type="text" v-model='selectStrFour' @touchstart="showPop(3)" readonly="readonly"
                   v-on:change="drawChart">
            <i class="iconfont icon-xia" @touchstart="showPop(3)"></i>
          </div>

        </div>
      </div>
      <div class="memberchart">

        <div id="chart">

        </div>

      </div>
    </div>
    <div class="pickerBox">
      <vue-pickers :show="show1" :selectData="datesType" v-on:cancel="close(0)" v-on:confirm="confirmFn"></vue-pickers>
    </div>
    <div class="pickerBox">
      <vue-pickers :show="show2" :selectData="growType" v-on:cancel="close(1)" v-on:confirm="confirmFn"></vue-pickers>
    </div>
    <div class="pickerBox">
      <vue-pickers :show="show3" :selectData="cardList" v-on:cancel="close(2)" v-on:confirm="confirmFn"></vue-pickers>
    </div>
    <div class="pickerBox">
      <vue-pickers :show="show4" :selectData="dataSort" v-on:cancel="close(3)" v-on:confirm="confirmFn"></vue-pickers>
    </div>
  </div>
</template>
<script>
  import dateHotel from '../operaCommon/dateHotel'
  import moment from 'moment'
  import formatKW from '../operaCommon/formatKW'
  import nothing from '../operaCommon/nothing'
  import {Toast} from 'mint-ui';
  import echarts from 'echarts'
  import _ from 'lodash'
  import VuePickers from 'vue-pickers'

  export default {
    data() {
      return {
        dataSort: {
          columns: 1,
          pData1: [{
            text: this.$t("member_dataSort_buyCount"),
            value: 1,
            code: 'buyCount'
          }, {text: this.$t("member_dataSort_charge"), value: 2, code: 'charge'}, {
            text: this.$t("member_dataSort_pay"),
            value: 3,
            code: 'pay'
          }]
        },
        growType: {
          columns: 1,
          pData1: [{text: this.$t("member_growType_0"), value: 1, type: 0}, {
            text: this.$t("member_growType_1"),
            value: 2,
            type: 1
          }, {text: this.$t("member_growType_2"), value: 3, type: 2}]
        },
        datesType: {
          columns: 1,
          pData1: [{text: this.$t('member_time_type_day'), value: 1}, {
            text: this.$t('member_time_type_month'),
            value: 2
          }]
        },
        cardList: {columns: 1, pData1: []},
        memberReq: !!sessionStorage.memberSearch ? JSON.parse(sessionStorage.memberSearch) : {
          code: '',
          dateType: '',
          d: null,
          level: '',
          name: '',
          type: '0',
          cardtype: ''
        },
        hotelName: '',
        memberInfo: {},
        newData: [],
        first: true,
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        selectStr: this.$t('member_time_type_month'),//事件类型默认值
        selectStrTwo: {text: this.$t('member_growType_0')},//发展方式默认值
        selectStrTree: this.$t('member_all_cardType'),//会员卡类默认值
        cardValue: '',//选中的会员卡类传给后台的赋值
        selectStrFour: this.$t('member_dataSort_buyCount'),//数据分类默认值
        dataSortselect: 'buyCount',//数据分类默认值
        selectedInput: 6,//点击默认不显示高亮
      }
    },
    mounted(value) {
      this.getMemberInfo(2);
      //四个弹框都先隐藏
      for (var i = 0; i < 4; i++) {
        document.getElementsByClassName('pickerBox')[i].classList.add('noShow');
      }
      //使进入该页面滚动条在顶部，而不是中间段
      document.getElementsByClassName('opera-member')[0].scrollTop = 0;

    },
    methods: {
      //弹框‘取消’按钮回调函数
      close(val) {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
        this.show4 = false;
        document.removeEventListener('touchmove', this.onHandler, false);
        this.removeDown(val)
        this.selectedInput = 6;
      },
      //弹框隐藏
      removeDown(val) {
        document.getElementsByClassName('pickerBox')[val].classList.add('noShow');
      },
      //弹框‘确定’按钮回调函数
      confirmFn(data) {
        if (this.show1) {
          this.selectStr = data.select1.text;
          var val = 0;
        }
        if (this.show2) {
          this.selectStrTwo = data.select1;
          var val = 1;
        }
        if (this.show3) {
          this.selectStrTree = data.select1.text;
          this.cardValue = data.select1.value;
          var val = 2;
        }
        if (this.show4) {
          this.selectStrFour = data.select1.text;
          this.dataSortselect = data.select1.code;
          var val = 3;
        }
        document.removeEventListener('touchmove', this.onHandler, false);
        this.selectedInput = 6;
        this.close(val);
        if (val != 3) {
          this.change();
        }
        if (val == 3) {
          this.drawChart();
        }

      },
      //静止滚动条滚动
      onHandler(e) {
        e.preventDefault();
      },
      //点击input框效果
      showPop(val) {
        if (val == 0) {
          this.show1 = !this.show1;
        }
        if (val == 1) {
          this.show2 = !this.show2;
        }
        if (val == 2) {
          this.show3 = !this.show3;
        }
        if (val == 3) {
          this.show4 = !this.show4;
        }
        if (this.show1 == true || this.show2 == true || this.show3 == true || this.show4 == true) {
          document.getElementsByClassName('pickerBox')[val].classList.remove('noShow');
          document.addEventListener('touchmove', this.onHandler, false);//禁止滚动条滚动
          this.selectedInput = val;
          if (this.show1 == true && this.show2 == true || this.show3 == true && this.show4 == true || this.show1 == true && this.show3 == true || this.show1 == true && this.show4 == true || this.show2 == true && this.show4 == true || this.show2 == true && this.show3 == true) {
            for (var i = 0; i < 4; i++) {
              this.close(i);
            }


          }
        } else {
          this.close(val);
          document.removeEventListener('touchmove', this.onHandler, false);//开启滚动条滚动
        }
      },
      change() {
        console.log("pp");
        this.getMemberInfo(1);
      },
      cardChange() {
        if (!this.first) {
          this.getMemberInfo(5);
        }
        this.first = false;
      },
      /*获取会员信息*/
      getMemberInfo(v) {
        console.log(v);
        if (this.selectStr == this.$t('member_time_type_day')) {
          this.memberReq.dateType = 'today'
        }
        if (this.selectStr == this.$t('member_time_type_month')) {
          this.memberReq.dateType = 'month'
        }
        this.memberReq.type = this.selectStrTwo.type ? this.selectStrTwo.type : '0';
        this.memberReq.cardtype = this.cardValue ? this.cardValue : '';
        sessionStorage.setItem("memberSearch", JSON.stringify(this.memberReq));
        this.$http.post('/mobilepmsapi/opera/report/getMemberCard', this.memberReq).then(res => {
          if (res.data.result == 0) {
            this.memberInfo = res.data.retVal;
            this.memberReq.d = moment(this.memberInfo.end).format('YYYY-MM-DD');
            this.hotelName = res.data.retVal.name;
            this.cardListSorting(this.memberInfo.cardList)
            this.drawChart();
          }
        });
      },
      //会员卡类后台数据重组符合picker的数组
      cardListSorting(item) {
        this.newData = [{text: this.$t('member_all_cardType'), value: ''}]
        for (let key in item) {
          this.newData.push({
            text: item[key],
            value: key,
          })
        }
        this.cardList.pData1 = this.newData;
      },
      drawChart() {
        var category = [];//曲线分类
        var datachart = [];//series数据
        var xAxis = [];//横坐标
        var cdata = this.dataSortselect == "buyCount" ? this.memberInfo.detail :
          (this.dataSortselect == "pay" ? this.memberInfo.detailCharge : this.memberInfo.detailPay);
        var t = {
          type: 'line',
          itemStyle: {
            normal: {
              color: 'rgb(255, 70, 131)'
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgb(255, 158, 68)'
              }, {
                offset: 1,
                color: 'rgb(255, 70, 131)'
              }])
            }
          },
          data: []
        };
        _.forEach(cdata, (el, index) => {
          category.push(index);
          t.data.push(el);

        })
        datachart.push(t);
        // console.log(datachart);
        var echartFs = lib.flexible.rem2px([0.3]);
        var myChart = echarts.init(document.getElementById('chart', 'customed'));
        var option = {
          title: {
            text: this.$t('member_time_trend'),
            left: 'center'
          },
          tooltip: {
            trigger: 'axis'
          },
          dataZoom: [{type: 'inside'}, {
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
              color: '#fff',
              shadowBlur: 3,
              shadowColor: 'rgba(0, 0, 0, 0.6)',
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          }],
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: category,
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: function (value, index) {
                if (value >= 1000)
                  return (value / 1000) + "K";
                return value;
              }
            }
          },
          series: datachart
        };
        myChart.setOption(option);
      },
      dateF(value) {
        return value == null ? "" : moment(value).format("YYYY-MM-DD");
      },
      getDate(time) {
        this.memberReq.d = time;
        console.log("ttt")
        this.getMemberInfo(3)
      },
      getHotel(hotel) {
        this.memberReq.code = hotel.code;
        this.memberReq.level = hotel.level;
        this.memberReq.name = hotel.descript;
        console.log(hotel.code)
        this.getMemberInfo(4)
      },
    },
    filters: {},
    computed: {},
    components: {
      'date-hotel': dateHotel,
      nothing,
      formatKW,
      VuePickers
    }
  }
</script>
<style lang='less'>
  .opera-slideInDown {
    bottom: 0rem;
    animation-name: none !important;
    animation: none !important;
  }

  .opera-member {
    background-color: #F6F8F9;

    .content {
      margin-top: 0.1067rem;
      background-color: #fff;

      .membertable {
        .select {
          width: 96%;
          margin: 0 auto;
          border-bottom: 1px dashed #ccc;

          .options {
            width: 50%;
            box-sizing: border-box;
            float: left;
            padding: 0.2667rem;
            height: 1.4133rem;
            border: none;

            .name {
              font-size: 0.32rem;
              line-height: 0.8rem;
              text-align: left;
              display: inline-block;
            }

            .parent {
              position: relative;
              margin-right: 0.4rem;
              margin-top: 0.0533rem;
              float: right;
              width: 1.9733rem;
              height: 0.64rem;
              padding-left: 0.1867rem;
              background: #fff;
              border: 1px solid #e8e8e8;

              &.focus {
                border: 1px solid #e0b47b;

                .iconfont {
                  color: #e0b47b;
                }
              }

              input {
                border: none;
                width: 100%;
                line-height: 0.6133rem;
                // height: 0.64rem;
                box-sizing: border-box;
              }

              .iconfont {
                position: absolute;
                right: 0.08rem;
                top: 0.0533rem;
              }
            }

            .option {
              box-sizing: border-box;
              width: 1.9733rem;
              height: 0.64rem;
              margin-top: 0.08rem;
              border: 1px solid #ccc;
              text-align: left;
              padding-left: 0.1333rem;
              margin-left: 0.1333rem;
              line-height: 0.64rem;
              outline: none;

              .icon-xia {
                float: right;
                margin-right: 0.0533rem;
              }
            }
          }

          // .mroption {
          //     text-align: right;
          // }
        }

        .memberMoney {
          height: 2.24rem;

          .mm {
            width: 33%;
            float: left;
            padding-top: 0.2133rem;
            position: relative;

            .money {
              text-align: center;
              font-size: 0.64rem;
              line-height: 0.96rem;
            }

            .category {
              text-align: center;
              font-size: 0.32rem;
              line-height: 0.5867rem;

              .detail {
                color: #4990E2;
              }
            }

            .line {
              position: absolute;
              right: 0;
              top: 0.8533rem;
              width: 1px;
              height: 0.5333rem;
              background-color: #CCCCCC;
            }
          }
        }

        .table {
          width: 96%;
          margin: 0 auto;

          tr {
            &:nth-of-type(2n) {
              background-color: #f5f5f5;
            }
          }

          th {
            width: 25%;
            height: 1.04rem;
            background: #F69C2D;
            color: #fff;
            font-size: 0.32rem;
            text-align: center;
          }

          td {
            text-align: center;
            color: #333;
            height: 1.0933rem;
          }
        }
      }

      .chartT {
        width: 96%;
        margin: 0 auto;

        .options {
          width: 50%;
          box-sizing: border-box;
          float: left;
          border: none;
          padding: 0.2667rem 0.1333rem;
          height: 1.4133rem;

          .name {
            font-size: 0.32rem;
            line-height: 0.8rem;
            text-align: left;
            display: inline-block;
          }

          .parent {
            position: relative;
            margin-right: 0.4rem;
            margin-top: 0.0533rem;
            float: right;
            width: 2.4rem;
            // width: 1.9733rem;
            height: 0.64rem;
            padding-left: 0.1867rem;
            background: #fff;
            border: 1px solid #e8e8e8;

            &.focus {
              border: 1px solid #e0b47b;

              .iconfont {
                color: #e0b47b;
              }
            }

            input {
              border: none;
              width: 100%;
              line-height: 0.6133rem;
              // height: 0.64rem;
              box-sizing: border-box;
            }

            .iconfont {
              position: absolute;
              right: 0.08rem;
              top: 0.0533rem;
            }
          }

          .option {
            box-sizing: border-box;
            width: 2.6rem;
            height: 0.64rem;
            margin-top: 0.08rem;
            border: 1px solid #ccc;
            text-align: left;
            padding-left: 0.1333rem;
            margin-left: 0.1333rem;
            line-height: 0.64rem;
            outline: none;

            .icon-xia {
              float: right;
              margin-right: 0.0533rem;
            }
          }

          // .option {
          //     outline: none;
          //     box-sizing: border-box;
          //     height: 0.64rem;
          //     margin-top: 0.08rem;
          //     border: 1px solid #ccc;
          //     text-align: left;
          //     margin-left: 0.0533rem;
          //     padding-left: 0.0533rem;
          //     line-height: 0.64rem;
          //     .icon-xia {
          //         float: right;
          //         margin-right: 0.0533rem;
          //     }
          // }
        }

        // .mroption {
        //     text-align: right;
        // }
      }

      .memberchart {

        #chart {
          width: 100%;
          margin: 0 auto;
          clear: both;
          padding: 0.5333rem 0;
          height: 8.8533rem;
          box-sizing: border-box;
        }
      }
    }
  }

  .member .noShow {
    display: none;
  }

  .member .pickerBox {
    position: fixed;
    z-index: 1000;
    bottom: 0;
    margin-top: 0px;
  }

  .member .pickerBox .area_ctrl {
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// member.vue?7b26c8f4